/**
 * TEMPORARILY DISABLED i18n configuration
 * This file initializes i18n in pass-through mode, returning English text directly.
 * The actual translations are handled by Google Translate.
 *
 * To re-enable native i18n:
 * 1. In main.jsx, uncomment: import './i18n'
 * 2. In main.jsx, remove/comment: import './i18n/disabled'
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import only English translations as the base
import enCommon from './locales/en/common.json';
import enAuth from './locales/en/auth.json';
import enDashboard from './locales/en/dashboard.json';
import enAccounts from './locales/en/accounts.json';
import enTransactions from './locales/en/transactions.json';
import enTransfers from './locales/en/transfers.json';
import enInvestments from './locales/en/investments.json';
import enCrypto from './locales/en/crypto.json';
import enLoans from './locales/en/loans.json';
import enCards from './locales/en/cards.json';
import enBudgets from './locales/en/budgets.json';
import enRewards from './locales/en/rewards.json';
import enSettings from './locales/en/settings.json';
import enErrors from './locales/en/errors.json';
import enAdmin from './locales/en/admin.json';
import enSidebar from './locales/en/sidebar.json';
import enBills from './locales/en/bills.json';

const resources = {
  en: {
    common: enCommon,
    auth: enAuth,
    dashboard: enDashboard,
    accounts: enAccounts,
    transactions: enTransactions,
    transfers: enTransfers,
    investments: enInvestments,
    crypto: enCrypto,
    loans: enLoans,
    cards: enCards,
    budgets: enBudgets,
    rewards: enRewards,
    settings: enSettings,
    errors: enErrors,
    admin: enAdmin,
    sidebar: enSidebar,
    bills: enBills
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en', // Force English - Google Translate handles other languages
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: [
      'common',
      'auth',
      'dashboard',
      'accounts',
      'transactions',
      'transfers',
      'investments',
      'crypto',
      'loans',
      'cards',
      'budgets',
      'rewards',
      'settings',
      'errors',
      'admin',
      'sidebar',
      'bills'
    ],
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
